// ⚠️ GÉNÉRÉ par scripts/sync-config.mjs — NE PAS ÉDITER À LA MAIN.
// Source : data/config.json
window.VALMA_DATA = {
  "basePrice": 9900,
  "render": {
    "breloqueRatio": 2.5,
    "overlap": 0.13,
    "canvasHeightFactor": 1.3,
    "background": "#ffffff"
  },
  "tailles": [],
  "couleurs": [
    {
      "id": "r",
      "label": "Jade rouge",
      "hex": "#D81E16",
      "energie": "Protection, force, vitalité, ancrage, énergie."
    },
    {
      "id": "t",
      "label": "Turquoise",
      "hex": "#6FC9D6",
      "energie": "Protection puissante, purification, clarté mentale, régulation, pensées positives."
    },
    {
      "id": "a",
      "label": "Agate blanche",
      "hex": "#F1EFEA",
      "energie": "Relaxation, stabilité, calme, migraines, tensions musculaires."
    },
    {
      "id": "c",
      "label": "Calcite orange",
      "hex": "#F4C44C",
      "energie": "Réparatrice, apaisante, aide au sommeil, bien-être, dissipe les douleurs."
    },
    {
      "id": "j",
      "label": "Jade verte",
      "hex": "#4A6A2F",
      "energie": "Aide aux relations saines, pierre revigorante, équilibre émotionnel.",
      "precommande": true
    },
    {
      "id": "q",
      "label": "Quartz rose",
      "hex": "#F4CCD4",
      "energie": "Réconfort, apaisement, paix, amitié, douceur intérieure."
    }
  ],
  "breloques": [
    {
      "id": "bl5_oeil_cleo",
      "label": "L'Œil de Cléo",
      "priceDelta": 0,
      "img": "breloque-bl5_oeil_cleo.png",
      "thumb": "thumb-breloque-bl5_oeil_cleo.png",
      "ratio": 1.7
    },
    {
      "id": "bl6_pyramide",
      "label": "Pyramide",
      "priceDelta": 0,
      "img": "breloque-bl6_pyramide.png",
      "thumb": "thumb-breloque-bl6_pyramide.png",
      "ratio": 1.7
    },
    {
      "id": "bl8_coeur_rose",
      "label": "Mon P'tit Cœur Rose",
      "priceDelta": 0,
      "img": "breloque-bl8_coeur_rose.png",
      "thumb": "thumb-breloque-bl8_coeur_rose.png",
      "ratio": 1.7
    },
    {
      "id": "bl9_coeur_blanc",
      "label": "Mon P'tit Cœur Blanc",
      "priceDelta": 0,
      "img": "breloque-bl9_coeur_blanc.png",
      "thumb": "thumb-breloque-bl9_coeur_blanc.png",
      "ratio": 1.7
    },
    {
      "id": "bl10_coeur_orange",
      "label": "Mon P'tit Cœur Orange",
      "priceDelta": 0,
      "img": "breloque-bl10_coeur_orange.png",
      "thumb": "thumb-breloque-bl10_coeur_orange.png",
      "ratio": 1.7
    },
    {
      "id": "bl11_coeur_jaune",
      "label": "Mon P'tit Cœur Jaune",
      "priceDelta": 0,
      "img": "breloque-bl11_coeur_jaune.png",
      "thumb": "thumb-breloque-bl11_coeur_jaune.png",
      "ratio": 1.7
    },
    {
      "id": "bl12_sunny_orange",
      "label": "Sunny Orange",
      "priceDelta": 0,
      "img": "breloque-bl12_sunny_orange.png",
      "thumb": "thumb-breloque-bl12_sunny_orange.png",
      "ratio": 1.7
    },
    {
      "id": "bl13_sunny_rose",
      "label": "Sunny Rose",
      "priceDelta": 0,
      "img": "breloque-bl13_sunny_rose.png",
      "thumb": "thumb-breloque-bl13_sunny_rose.png",
      "ratio": 1.7
    },
    {
      "id": "bl14_sunny_jaune",
      "label": "Sunny Jaune",
      "priceDelta": 0,
      "img": "breloque-bl14_sunny_jaune.png",
      "thumb": "thumb-breloque-bl14_sunny_jaune.png",
      "ratio": 1.7
    },
    {
      "id": "bl15_sunny_blanc",
      "label": "Sunny Blanc",
      "priceDelta": 0,
      "img": "breloque-bl15_sunny_blanc.png",
      "thumb": "thumb-breloque-bl15_sunny_blanc.png",
      "ratio": 1.7
    },
    {
      "id": "bl16_medaillon_soleil",
      "label": "Médaillon Soleil",
      "priceDelta": 0,
      "img": "breloque-bl16_medaillon_soleil.png",
      "thumb": "thumb-breloque-bl16_medaillon_soleil.png",
      "ratio": 1.35
    },
    {
      "id": "bl17_petit_poisson",
      "label": "Petit Poisson",
      "priceDelta": 0,
      "img": "breloque-bl17_petit_poisson.png",
      "thumb": "thumb-breloque-bl17_petit_poisson.png",
      "ratio": 1.35
    },
    {
      "id": "bl18_coeur_etoile",
      "label": "Cœur Étoilé",
      "priceDelta": 0,
      "img": "breloque-bl18_coeur_etoile.png",
      "thumb": "thumb-breloque-bl18_coeur_etoile.png",
      "ratio": 1.7
    }
  ],
  "colliers": {
    "r": {
      "img": "collier-noemie-r.png",
      "cx": 0.5037,
      "yb": 0.93468,
      "rw": 0.17778
    },
    "t": {
      "img": "collier-noemie-t.png",
      "cx": 0.50572,
      "yb": 0.93401,
      "rw": 0.19798
    },
    "a": {
      "img": "collier-noemie-a.png",
      "cx": 0.5064,
      "yb": 0.93401,
      "rw": 0.1468
    },
    "c": {
      "img": "collier-noemie-c.png",
      "cx": 0.50168,
      "yb": 0.93064,
      "rw": 0.18047
    },
    "j": {
      "img": "collier-noemie-j.png",
      "cx": 0.5037,
      "yb": 0.93535,
      "rw": 0.18047
    },
    "q": {
      "img": "collier-noemie-q.png",
      "cx": 0.50168,
      "yb": 0.93872,
      "rw": 0.167
    }
  }
};